[
  {
    "code" : "0",
    "description" : "Guarantee waiver",
    "grnRequired" : true,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : true
  },
  {
    "code" : "1",
    "description" : "Comprehensive guarantee",
    "grnRequired" : true,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : true
  },
  {
    "code" : "2",
    "description" : "Individual guarantee",
    "grnRequired" : true,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "3",
    "description" : "Cash deposit guarantee",
    "grnRequired" : false,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : true,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "4",
    "description" : "Flat-rate voucher",
    "grnRequired" : true,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "5",
    "description" : "Guarantee waiver where the amount is below threshold",
    "grnRequired" : false,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "8",
    "description" : "Guarantee not required (public bodies)",
    "grnRequired" : false,
    "referenceShouldBeSent" : false,
    "otherReferenceAllowed" : true,
    "otherReferenceRequired" : true,
    "withBalance" : false
  },
  {
    "code" : "9",
    "description" : "Individual guarantee with multiple usage",
    "grnRequired" : true,
    "referenceShouldBeSent" : true,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : true
  },
  {
    "code" : "A",
    "description" : "Guarantee waiver by agreement",
    "grnRequired" : false,
    "referenceShouldBeSent" : false,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "B",
    "description" : "Guarantee TIR-carnet",
    "grnRequired" : false,
    "referenceShouldBeSent" : false,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "J",
    "description" : "Guarantee not required for departure to transit",
    "grnRequired" : false,
    "referenceShouldBeSent" : false,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  },
  {
    "code" : "R",
    "description" : "Guarantee not required for goods carried on the Rhine or Danube",
    "grnRequired" : false,
    "referenceShouldBeSent" : false,
    "otherReferenceAllowed" : false,
    "otherReferenceRequired" : false,
    "withBalance" : false
  }
]
